import React, { useEffect, useState } from 'react';

import { Row } from '@opendoor/atoms/box';
import { Checkbox } from '@opendoor/atoms/checkbox';
import { Text } from '@opendoor/atoms/text';

import { Card } from './Card';
import { INotificationCategory } from './NotificationPreferences';

interface INotificationPreferenceCardProps {
  key: number;
  notificationPreference: INotificationCategory;
  updateNotificationCategories: (category: string, enabled: boolean) => void;
}
const NotificationPreferenceCard: React.FC<INotificationPreferenceCardProps> = (
  props: INotificationPreferenceCardProps,
) => {
  const { notificationPreference, updateNotificationCategories } = props;
  const [enabled, setEnabled] = useState<boolean>(notificationPreference.enabled);

  useEffect(() => {
    updateNotificationCategories(notificationPreference.categoryKey, enabled);
    // eslint-disable-next-line
  }, [enabled]);

  return (
    <Card className="w-full gap-2">
      <Row className="w-full items-baseline justify-between">
        <Text as="span" className="text-label-md font-medium">
          {notificationPreference.label}
        </Text>
        <Checkbox
          checked={enabled}
          onCheckedChange={setEnabled}
          value={notificationPreference.categoryKey}
          aria-label={notificationPreference.label || 'Toggle notification preference'}
          size="sm"
          analyticsName={`notification-preference-${notificationPreference.categoryKey}`}
        />
      </Row>
      <div>{notificationPreference.description}</div>
    </Card>
  );
};
export default NotificationPreferenceCard;
